export default __webpack_public_path__ + "static/media/rotateSvg.7e91182f.svg";